import type { Event } from '@casetrace/shared';
import { eventAttachments } from '../event-attachments';
import { AttachmentList } from '../attachment-list';
import { EventParticipants } from '../event-participants';
import { EventMetadataSection } from '../event-metadata-section';

function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat('nb-NO', { dateStyle: 'full', timeStyle: 'short' }).format(
    new Date(iso),
  );
}

function ExpandedContent({ event }: { event: Event }) {
  const attachments = eventAttachments(event);

  return (
    <div className="flex flex-col gap-3">
      <p className="text-xs text-text-tertiary">{formatDateTime(event.timestamp)}</p>

      {event.contentPreview ? (
        <p className="whitespace-pre-wrap text-xs leading-relaxed text-text-secondary">
          {event.contentPreview}
        </p>
      ) : (
        <p className="text-xs italic text-text-tertiary">Ingen forhåndsvisning tilgjengelig.</p>
      )}

      {attachments.length > 0 && (
        <div>
          <p className="mb-1.5 text-[10px] font-semibold uppercase tracking-widest text-text-tertiary">
            Vedlegg
          </p>
          <AttachmentList caseId={event.caseId} attachments={attachments} />
        </div>
      )}

      <EventParticipants event={event} />

      <EventMetadataSection event={event} />
    </div>
  );
}

interface EventCardExpandedPanelProps {
  expandedEvent: Event | undefined;
}

export function EventCardExpandedPanel({ expandedEvent }: EventCardExpandedPanelProps) {
  return (
    <div className="border-t px-3 pb-3 pt-2.5" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
      {expandedEvent ? (
        <ExpandedContent event={expandedEvent} />
      ) : (
        <p className="text-xs text-text-tertiary">Laster…</p>
      )}
    </div>
  );
}
